import { CredentialAction } from '../actions/credential';
import { SwitchCustomerAction } from '../actions/session';
import { APIError } from '../APIError';
import { CredentialSchema, Store, Subscriptions } from '../types';

export type State = {
  readonly schemasLoading: boolean;
  readonly schemas: Array<CredentialSchema>;
  readonly subscriptions: Array<Subscriptions>;
  readonly schemaError: APIError | null;
};

export const INITIAL_CREDENTIAL_STATE: State = {
  schemas: [],
  subscriptions: [],
  schemasLoading: false,
  schemaError: null,
};

const credentialReducer = (
  state: State = INITIAL_CREDENTIAL_STATE,
  action: CredentialAction | SwitchCustomerAction,
): State => {
  switch (action.type) {
    case 'set_credential_schema':
      return {
        ...state,
        schemaError: INITIAL_CREDENTIAL_STATE.schemaError,
        schemas: action.schemas || [],
        schemasLoading: false,
      };

    case 'set_credential_schema_loading':
      return {
        ...state,
        schemasLoading: action.loading,
      };

    case 'set_credential_schema_error':
      return {
        ...state,
        schemas: INITIAL_CREDENTIAL_STATE.schemas,
        schemaError: action.err,
        schemasLoading: false,
      };

    case 'set_subscriptions':
      return {
        ...state,
        subscriptions: action.subscriptions,
      };

    default:
      return state;
  }
};

export default credentialReducer;

// ------------
// Selectors
// -------------

export const credentialSelector = {
  getSchemaError: (store: Store): APIError | null =>
    store.credential.schemaError,
  getSchemaLoading: (store: Store): boolean => store.credential.schemasLoading,
  getSchemas: (store: Store): Array<CredentialSchema> =>
    store.credential.schemas,
  getSubscriptions: (store: Store): Array<Subscriptions> =>
    store.credential.subscriptions,
  hasFetchedSubscriptions: (store: Store): boolean =>
    store.credential.subscriptions !== INITIAL_CREDENTIAL_STATE.subscriptions,
};
